export const TEXT_LIMIT_CHARACTER = {
  ShortDescription: {
    maxLength: 30,
  },
  LongDescription: {
    maxLength: 30,
  },
  MarketingDescription: {
    maxLength: 1000,
  },
  'Construction.Embellishments': {
    maxLength: 30,
  },
};

// Looks up TEXT_LIMIT_CHARACTER by the full field path first (e.g. 'Construction.Embellishments'),
// falling back to the bare property name so the limit still applies under
// category-specific module prefixes (e.g. 'ComplianceFirearms.BhtsCode').
export const getTextLimitCharacter = (fieldFullPath) => {
  if (!fieldFullPath) return undefined;

  if (TEXT_LIMIT_CHARACTER[fieldFullPath]) {
    return TEXT_LIMIT_CHARACTER[fieldFullPath];
  }

  const propertyName = fieldFullPath.split('.').pop();
  return TEXT_LIMIT_CHARACTER[propertyName];
};

export const HIERARCHY_CATEGORIES_MAP = {
  Firearms: {
    subcategories: [
      'Pistol',
      'Revolver',
      'Rifle',
      'Shotgun',
      'BlackPowder',
      'Other',
    ],
    classes: {
      Pistol: [],
      Revolver: [],
      Rifle: ['SemiAuto', 'Bolt', 'Lever', 'SingleShot', 'Pump'],
      Shotgun: [
        'SemiAuto',
        'Pump',
        'Bolt',
        'SideBySide',
        'OverUnder',
        'SingleShot',
      ],
      'Black Powder': ['Rifle', 'Pistol', 'Revolver', 'StarterPistol'],
      Other: [],
    },
  },
  Ammunition: {
    subcategories: ['Handgun', 'Rifle', 'Rimfire', 'Shotshell'],
    classes: {
      Centerfire: [],
      Rimfire: [],
      Shotshell: [],
    },
  },
  Optics: {
    subcategories: [
      'Handgun',
      'Rifle',
      'Observation',
      'Thermal',
      'NightVision',
      'OpticsAccessories',
    ],
    classes: {
      Handgun: ['RedDot', 'Reflex', 'Holographic', 'LPVO', 'Variable', 'Prism'],
      Rifle: ['RedDot', 'Reflex', 'Holographic', 'LPVO', 'Variable', 'Prism'],
      Observation: ['SpottingScopes', 'Binoculars', 'Rangefinders'],
      Thermal: [
        'Rifle',
        'Handgun',
        'Binoculars',
        'SpottingScopes',
        'Monocular',
      ],
      'Night Vision': [
        'Rifle',
        'Handgun',
        'Binoculars',
        'SpottingScopes',
        'Monocular',
      ],
      'Optics Accessories': ['Mounts', 'Levels', 'Other'],
    },
  },
  Suppressors: {
    subcategories: ['Rifle', 'Pistol', 'Shotgun', 'Accessories'],
    classes: {
      Rifle: [],
      Pistol: [],
      Rimfire: [],
      Accessories: [],
    },
  },
  Accessories: {
    subcategories: [
      'Magazines',
      'Holsters',
      'Cutlery',
      'GunParts',
      'GunSafetyStorage',
      'GunCleaning',
      'ShootingAccessories',
    ],
    classes: {
      Magazines: [],
      Holsters: [],
      Cutlery: [],
      'Gun Parts': [],
      'Gun Safety Storage': [],
      'Gun Cleaning': [],
      ShootingAccessories: [],
    },
  },
  Reloading: {
    subcategories: [],
    classes: [],
  },
  'Air Gun': {
    subcategories: ['Pistol', 'Rifle', 'Other'],
    classes: {
      Rifle: [],
      Pistol: [],
      Accessories: [],
      Other: [],
    },
  },
};

export const BASE_FEATURES = 'Features';

export const CATEGORY_FIREARMS = 'Firearms';
export const CATEGORY_SHOTGUN = 'Shotgun';
export const CATEGORY_HANDGUN = 'Handgun';
export const CATEGORY_BLACK_POWDER = 'Black Powder';
export const CATEGORY_RIFLE = 'Rifle';
export const CATEGORY_RIMFIRE = 'Rimfire';
export const CATEGORY_SHOTSHELL = 'Shotshell';
export const CATEGORY_OBSERVATION = 'Observation';
export const CATEGORY_NIGHT_VISION = 'Night Vision';
export const CATEGORY_THERMAL = 'Thermal';
export const CATEGORY_OPTICS_ACCESSORIES = 'Optics Accessories';

// Accessories Categories
export const CATEGORY_ACCESSORIES_CUTLERY = 'Cutlery';
export const CATEGORY_ACCESSORIES_GUN_CLEANING = 'Gun Cleaning';
export const CATEGORY_ACCESSORIES_GUN_PARTS = 'Gun Parts';
export const CATEGORY_ACCESSORIES_GUN_SAFETY_STORAGE = 'Gun Safety/Storage';
export const CATEGORY_ACCESSORIES_HOLSTERS = 'Holsters';
export const CATEGORY_ACCESSORIES_MAGAZINES = 'Magazines';
export const CATEGORY_ACCESSORIES_SHOOTING_ACCESSORIES = 'Shooting Accessories';

export const CATEGORY_SUPPRESSORS = 'Suppressors';
export const CATEGORY_AMMUNITION = 'Ammunition';
export const CATEGORY_OPTICS = 'Optics';
export const CATEGORY_ACCESSORIES = 'Accessories';

export const CONSTRUCTION_MODULE = 'Construction';

export const OPTICS_RIFLE_ELEVATION_TURRET_TRAVEL =
  'AttributesOpticsRifle.ElevationTurretTravel';
export const OPTICS_RIFLE_WINDAGE_TURRET_TRAVEL =
  'AttributesOpticsRifle.WindageTurretTravel';
export const OPTICS_RIFLE_ELEVATION_TURRET_TRAVEL_POSTFIX =
  'AttributesOpticsRifle.ElevationTurretTravelPostfix';
export const OPTICS_RIFLE_WINDAGE_TURRET_TRAVEL_POSTFIX =
  'AttributesOpticsRifle.WindageTurretTravelPostfix';
export const OPTICS_RIFLE_FOV_MIN_MAGNIFICATION =
  'AttributesOpticsRifle.FieldOfViewMinMagnification';
export const OPTICS_RIFLE_FOV_MAX_MAGNIFICATION =
  'AttributesOpticsRifle.FieldOfViewMaxMagnification';
export const OPTICS_RIFLE_LENGTH = 'AttributesOpticsRifle.Length';
export const OPTICS_RIFLE_WEIGHT = 'AttributesOpticsRifle.Weight';
export const OPTICS_RIFLE_EYE_RELIEF_IN = 'AttributesOpticsRifle.EyeReliefIn';

export const OPTICS_OBSERVATION_WEIGHT = 'AttributesOpticsObservation.Weight';

export const ACCESSORIES_GUN_CLEANING_SIZE =
  'AttributesAccessoriesGunCleaning.Size';

export const OPTICS_NIGHT_VISION_MAGNIFICATION_DIGITAL_OPTICAL =
  'AttributesOpticsNightVision.MagnificationDigitalOptical';
export const OPTICS_NIGHT_VISION_MAGNIFICATION_DIGITAL_DIGITAL_ZOOM =
  'AttributesOpticsNightVision.MagnificationDigitalDigitalZoom';
export const OPTICS_NIGHT_VISION_TOTAL_EFFECTIVE_MAGNIFICATION =
  'AttributesOpticsNightVision.TotalEffectiveMagnification';
export const OPTICS_NIGHT_VISION_EYE_RELIEF_IN =
  'AttributesOpticsNightVision.EyeReliefIn';
export const OPTICS_NIGHT_VISION_SENSOR_RESOLUTION_WIDTH =
  'AttributesOpticsNightVision.SensorResolutionWidth';
export const OPTICS_NIGHT_VISION_SENSOR_RESOLUTION_HEIGHT =
  'AttributesOpticsNightVision.SensorResolutionHeight';

export const OPTICS_THERMAL_MAGNIFICATION_DIGITAL_OPTICAL =
  'AttributesOpticsThermal.MagnificationDigitalOptical';
export const OPTICS_THERMAL_MAGNIFICATION_DIGITAL_DIGITAL_ZOOM =
  'AttributesOpticsThermal.MagnificationDigitalDigitalZoom';
export const OPTICS_THERMAL_TOTAL_EFFECTIVE_MAGNIFICATION =
  'AttributesOpticsThermal.TotalEffectiveMagnification';
export const OPTICS_THERMAL_EYE_RELIEF_IN =
  'AttributesOpticsThermal.EyeReliefIn';
export const OPTICS_THERMAL_LENGTH = 'AttributesOpticsThermal.Length';
export const OPTICS_THERMAL_HEIGHT = 'AttributesOpticsThermal.Height';
export const OPTICS_THERMAL_WIDTH = 'AttributesOpticsThermal.Width';

export const OPTICS_OPTICS_ACCESSORIES_HEIGHT =
  'AttributesOpticsOpticsAccessories.Height';

export const ACCESSORIES_OPTICS_FIELDS_DISABLED_WHEN_OPTIC_NOT_INCLUDED = [
  'Accessories.AccessoriesOptics.TypeIncluded',
  'Accessories.AccessoriesOptics.Magnification',
  'Accessories.AccessoriesOptics.Objective',
  'Accessories.AccessoriesOptics.MainTubeSize',
  'Accessories.AccessoriesOptics.Reticle',
  'Accessories.AccessoriesOptics.AdjustmentType',
  // Firearms
  'AccessoriesFirearms.AccessoriesOptics.TypeIncluded',
  'AccessoriesFirearms.AccessoriesOptics.Magnification',
  'AccessoriesFirearms.AccessoriesOptics.Objective',
  'AccessoriesFirearms.AccessoriesOptics.MainTubeSize',
  'AccessoriesFirearms.AccessoriesOptics.Reticle',
  'AccessoriesFirearms.AccessoriesOptics.AdjustmentType',
  // Suppressors
  'AccessoriesSuppressors.AccessoriesOptics.TypeIncluded',
  'AccessoriesSuppressors.AccessoriesOptics.Magnification',
  'AccessoriesSuppressors.AccessoriesOptics.Objective',
  'AccessoriesSuppressors.AccessoriesOptics.MainTubeSize',
  'AccessoriesSuppressors.AccessoriesOptics.Reticle',
  'AccessoriesSuppressors.AccessoriesOptics.AdjustmentType',
];

export const DEFAULT_MODULE_NAMES = ['Pricing', 'ShippingLogistics'];

export const CATEGORY_FIREARMS_MODULE_NAMES = [
  'ConstructionFirearms',
  'AttributesFirearms',
  'AccessoriesFirearms',
  'NfaFirearms',
  'ComplianceFirearms',
  ...DEFAULT_MODULE_NAMES,
];

export const CATEGORY_AMMUNITION_MODULE_NAMES = [
  'ComplianceAmmunition',
  'Pricing',
  'ShippingLogistics',
];

export const CATEGORY_SUPPRESSORS_MODULE_NAMES = [
  'AttributesSuppressors',
  'AccessoriesSuppressors',
  'ComplianceSuppressors',
  'Pricing',
  'ShippingLogistics',
];

export const CATEGORY_OPTICS_MODULE_NAMES = [
  'ComplianceOptics',
  'Pricing',
  'ShippingLogistics',
];

export const CATEGORY_ACCESSORIES_MODULE_NAMES = [
  'ComplianceAccessories',
  ...DEFAULT_MODULE_NAMES,
];

export const CATEGORY_OTHERS_MODULE_NAMES = [
  'Attributes',
  'Accessories',
  'Compliance',
  'Nfa',
  'Construction',
  ...DEFAULT_MODULE_NAMES,
];
